"use strict";
$.fn.textfill = function (clean, fillheight) {
    $('h3 a, h2 a, h1 a, p a.textfill', this).css('font-size', "");
    if (!clean) {
        textFill("h2 a", this);
        textFill("h1 a", this);
        textFill("h3 a", this);
        textFill("p a.textfill", this);
        if (fillheight) {
            cleanHeight('h2 a', this);
            cleanHeight('h1 a', this);
            cleanHeight('h3 a', this);
            cleanHeight('p a.textfill', this);
        }
    }
    return this;
}

var cleanHeight = function (sel, th) {
    $(sel, th).parent().css('height', 'auto');
}

var textFill = function (sel, th) {
    var sizes = [];
    var ourTexts = $(sel, th);
    $(ourTexts).parent().css('height', '');
    var fontSizepx = ourTexts.css('font-size') ? ourTexts.css('font-size') : '27px';
    var fontSizeInit = fontSizepx.replace(/[^-\d\.]/g, '');
    var fontSize = parseInt(fontSizeInit);
    for (var i = 0; i < ourTexts.length; i++) {
        var ourText = ourTexts[i];
        var maxHeight = $(ourText).parent().height();
        var maxWidth = $(ourText).parent().width();
        var textHeight;
        var textWidth;
        
        do {
            $(ourText).css('line-height', (fontSize + 6) + 'px');
            $(ourText).css('font-size', fontSize);
            textHeight = $(ourText).height();
            textWidth = $(ourText).width();
            fontSize = fontSize - 1;
        } while ((textHeight > maxHeight || textWidth > maxWidth) && fontSize > 10);
        fontSize++;
        sizes.push(fontSize);
    }
    var resultSize = Math.min.apply(null, sizes);
    ourTexts.css('font-size', resultSize);
    ourTexts.css('line-height', (resultSize + 6) + 'px');
}


window.onresize = onResize;
window.addEventListener("orientationchange", function () {
    onResize();
    setTimeout(function () {
        onResize();
        $('[data-sticky]').foundation('_calc', true);
    }, 100);
    setTimeout(function () {
        onResize();
        $('[data-sticky]').foundation('_calc', true);
    }, 300);
    setTimeout(function () {
        onResize();
        $('[data-sticky]').foundation('_calc', true);
    }, 700);
});
var onResize = function () {
    if ($(window).width() < 768) {
        $('.text-fill-section').each(function () {
            $(this).textfill(true, false);
        });
    }
    else {
        $('.text-fill-section').each(function () {
            $(this).textfill(false, !$(this).data('fillHeight'));
        });
    }
};

onResize();

$(window).on("load", function () {
    onResize();
}); 